import React from 'react';
import moment from 'moment';
import { Check, X } from 'react-feather';
import getLabel from '../translations/messages';

export const booleanFormatter = (value) => {
  if (value === 'true' || value === true) {
    return <Check size={16} />;
  }

  if (value === 'false' || value === false) {
    return <X size={16} />;
  }

  return '';
};

export const dateFormatter = (value) => {
  if (!value) {
    return '';
  }

  const parsed = moment(value);

  if (!parsed.isValid()) {
    return '';
  }

  return parsed.format('DD/MM/YYYY');
};

export const dateTimeFormatter = (value) => {
  if (!value) {
    return '';
  }

  const parsed = moment(value);

  if (!parsed.isValid()) {
    return '';
  }

  return parsed.format('DD/MM/YYYY HH:mm:ss');
};

export const localeFormatter = locale => prefix => value => (
  getLabel(locale, prefix + '.' + value)
);

export const decimalFormatter = digits => value => {
  return String(value.toFixed(digits));
};



// WEBPACK FOOTER //
// ./src/main/functions/textFormatter.js